import {combineReducers} from 'redux';
import {appState} from './appStateReducer';

const rootReducer = combineReducers({
    appState
});

export default rootReducer;
